import { BehaviorSubject, Subject } from 'rxjs';

export class RemoteMediaEventBus {
  static readonly handleVideoPrivacy$ = new BehaviorSubject<string>('');
  static readonly resetRemoteVideo$ = new Subject<void>();
}
